/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/display-name */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useEffect, useMemo, useState } from 'react';
import { isWeb, isNative, fullWidth } from '@global/screens';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import * as Layout from '@components/screen/Layout';
import ImageContainV2 from '@components/global/ImageContainV2';
import Carousel from '@components/slider/v2/Carousel';

import CatalogTab from '@/screens/catalog/components/CatalogTab';
import Brand from '@/screens/catalog/components/pages/Brand';
import Categories from '@/screens/catalog/components/pages/Categories';
import Product from '@/screens/catalog/components/pages/Product';
import Promo from '@/screens/catalog/components/pages/Promo';

import useApi from '@/hooks/useApi';
import { MsCatalog } from '@api/ms-catalog';

const MobileMainBanner = React.memo(({ data, navigation }) => {
  const [imageHeight, setImageHeight] = useState(0);

  const onRedirectBanner = ({ id, title }) => {
    navigation.navigate('CatalogPromoScreen', {
      titleScreen: title,
      name: title,
      id: id,
    });
  };

  const settings = {
    dots: false,
  };

  const onChangeHeight = (height) => {
    if (isNative) {
      setImageHeight(height);
    }
  };

  const renderItem = (item, index) => {
    return (
      <TouchableOpacity
        activeOpacity={0.8}
        style={{ width: fullWidth, ...(isNative ? styles.imageSlider : {}) }}
        onPress={() => onRedirectBanner(item)}
        key={index}>
        <ImageContainV2
          source={item.image}
          compressWidth={250}
          style={{ width: fullWidth }}
          onChangeHeight={onChangeHeight}
        />
      </TouchableOpacity>
    );
  };

  return !isWeb && data?.length ? (
    <>
      {isNative ? (
        <View style={{ width: fullWidth, height: imageHeight }}>
          <Carousel
            data={data}
            renderItem={({ item, index }) => renderItem(item, index)}
            sliderWidth={fullWidth}
            itemWidth={fullWidth}
            style={{ width: fullWidth, height: imageHeight }}
          />
        </View>
      ) : (
        <Carousel {...settings}>{data.map(renderItem)}</Carousel>
      )}
    </>
  ) : (
    false
  );
});

const CatalogScreen = (props) => {
  const [activeTab, setActiveTab] = useState('');
  const [mainBanner, setMainBanner] = useState([]);

  const getCMS = useApi(MsCatalog.getCMS);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (props?.route?.params?.tab && props?.route?.params?.tab != activeTab) {
        setActiveTab(props.route.params.tab);
      } else if (!props?.route?.params?.tab || !activeTab) {
        setActiveTab('product');
      }
    }
    return () => {
      mounted = false;
    };
  }, [props]);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      setMainBanner([]);
      getMobileMainBanner();
      if (props?.route?.params?.activitiyId && !isWeb) {
        props.navigation.setOptions({
          headerLeft: () => (
            <Layout.BackCustom onCallback={() => goToActivity()} />
          ),
        });
      }
    }
    return () => {
      mounted = false;
    };
  }, [props]);

  const goToActivity = () => {
    props.navigation.navigate('SalesActivityNavigator', {
      screen: 'SalesActivityScreen',
      params: {
        id: props.route.params.activitiyId,
        direct: 'npd_presentation',
      },
    });
  };

  const getMobileMainBanner = async () => {
    try {
      const response = await getCMS.request({
        params: {
          filter: {
            is_active: true,
            is_slide_banner: true,
            banner_mobile: { $ne: '' },
          },
          limit: 8,
          skip: 0,
        },
      });
      if (response?.data?.data?.length) {
        const result = response.data.data.map((item) => {
          return {
            id: item._id,
            title: item.title,
            image: item.banner_mobile,
            page_type: item.page_type,
            is_slide_banner: item.is_slide_banner,
          };
        });
        setMainBanner(result);
      } else {
        setMainBanner([]);
      }
    } catch (error) {
      setMainBanner([]);
    }
  };

  const onChangeTab = (value) => {
    setActiveTab(value);
    props.navigation.setParams({ tab: value != 'product' ? value : '' });
  };

  const TabContent = useMemo(
    () =>
      activeTab == 'product' ? (
        <Brand {...props} />
      ) : ['best-seller', 'new-arrival'].includes(activeTab) ? (
        <Product {...props} activeTab={activeTab} />
      ) : activeTab == 'promo' ? (
        <Promo {...props} />
      ) : activeTab === 'categories' ? (
        <Categories {...props} />
      ) : (
        false
      ),
    [activeTab],
  );

  const MainBanner = useMemo(() => {
    return mainBanner?.length ? (
      <MobileMainBanner data={mainBanner} navigation={props.navigation} />
    ) : (
      false
    );
  }, [mainBanner]);

  const ListContent = useMemo(() => {
    return activeTab == 'product' ? (
      <Brand
        {...props}
        activeTab={activeTab}
        onChangeTab={(val) => onChangeTab(val)}
        mainBanner={MainBanner}
      />
    ) : ['best-seller', 'new-arrival'].includes(activeTab) ? (
      <Product
        {...props}
        activeTab={activeTab}
        onChangeTab={(val) => onChangeTab(val)}
        mainBanner={MainBanner}
      />
    ) : activeTab == 'promo' ? (
      <Promo
        {...props}
        activeTab={activeTab}
        onChangeTab={(val) => onChangeTab(val)}
        mainBanner={MainBanner}
      />
    ) : activeTab == 'categories' ? (
      <Categories
        {...props}
        activeTab={activeTab}
        onChangeTab={(val) => onChangeTab(val)}
        mainBanner={MainBanner}
      />
    ) : (
      false
    );
  }, [activeTab, MainBanner]);

  return (
    <Layout.Container>
      {isWeb ? (
        <>
          {!props?.route?.params?.activitiyId ? (
            <Layout.Back
              title="Sales Activity"
              onCallback={() => goToActivity()}
            />
          ) : (
            false
          )}
          <Layout.Title title="Product Catalog" />

          <CatalogTab
            activeTab={activeTab}
            onCallback={(value) => onChangeTab(value)}
          />

          {TabContent}
        </>
      ) : (
        ListContent
      )}
    </Layout.Container>
  );
};

const styles = StyleSheet.create({
  imageSlider: { flex: 1 },
});

export default CatalogScreen;
